import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../environments/environment';
import { HttpParameterCodec } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DigitalBarcodeServiceService {
  
  private barcodeUrl = environment.barcodeUrl;  // URL to web api

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient) { 
    
  }

  getUserDetails(encryptedData){
    let param = new HttpParams().set("d",encodeURIComponent(encryptedData));
    return this.http.get(this.barcodeUrl, {params: param})
  }
}

